import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-physical';
export var ID = 'icon-physical';
/* eslint-disable max-len */

export var SVGPhysical = function SVGPhysical() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 69 69"
  }, React.createElement("g", {
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M25.743 25.74c4.808-4.807 12.617-4.824 17.452-.057L55.35 10.24C42.785-.577 23.81-.03 11.89 11.89-.03 23.81-.574 42.786 10.24 55.348l15.445-12.155c-4.768-4.834-4.75-12.644.058-17.452zM58.76 13.65L43.317 25.805c4.766 4.835 4.75 12.644-.058 17.452-4.81 4.807-12.617 4.824-17.452.057L13.652 58.758c12.562 10.816 31.538 10.27 43.458-1.65 11.92-11.92 12.465-30.896 1.65-43.458z"
  }), React.createElement("path", {
    d: "M42.74 26.26c-4.55-4.55-11.928-4.55-16.478 0-4.55 4.55-4.55 11.93 0 16.477 4.55 4.55 11.927 4.55 16.478.002 4.55-4.552 4.55-11.93 0-16.48zM29.765 39.235c-2.616-2.615-2.616-6.857 0-9.473 2.615-2.616 6.856-2.615 9.473 0 2.614 2.616 2.614 6.857 0 9.474-2.617 2.615-6.858 2.615-9.473 0z"
  }), React.createElement("path", {
    d: "M10.52 58.48c-13.225-13.223-13.225-34.74 0-47.963 13.223-13.223 34.74-13.223 47.962 0 13.224 13.224 13.224 34.74 0 47.965-13.223 13.223-34.74 13.223-47.963-.002zm47.443-47.444C45.025-1.9 23.975-1.9 11.038 11.036-1.9 23.973-1.9 45.023 11.038 57.96c12.937 12.938 33.99 12.938 46.925.002 12.937-12.937 12.937-33.988 0-46.926z"
  })));
};
/* eslint-disable max-len */

var Physical = function Physical(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGPhysical
  });
};

Physical.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Physical;